import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ec9e1a9&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4ec9e1a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec9e1a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec9e1a9')) {
      api.createRecord('4ec9e1a9', component.options)
    } else {
      api.reload('4ec9e1a9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ec9e1a9&scoped=true&", function () {
      api.rerender('4ec9e1a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Urbanwarehouse/modules/edit-auth-dialog/index.vue"
export default component.exports